"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toBusinessCentralCompany = exports.ImportSource = void 0;
var ImportSource;
(function (ImportSource) {
    // Legacy tenant label kept for backward compatibility in existing data/flows.
    ImportSource["Master"] = "Gourmetta Update";
    ImportSource["MasterV2"] = "MASTER_v2";
    /**
     * Client-only source. Master data (items, categories, prices) comes from
     * the master exclusively; 077_02 contributes nothing but its debtors. Which
     * import steps actually run per source is configured in the bc-import
     * extension.
     *
     * Legacy label: the tenant was provisioned as `077_Gastronomia` and carries
     * that label in existing rows; `normalizeBcCompany` and
     * `toImportSourceLabel` translate it to `077_02`.
     */
    ImportSource["Gastronomia"] = "077_02";
})(ImportSource || (exports.ImportSource = ImportSource = {}));
/**
 * We keep the old tenant flag for the application data model, but map it to
 * the new BC tenant key for all Business Central calls.
 */
var toBusinessCentralCompany = function (source) {
    return source === ImportSource.Master ? ImportSource.MasterV2 : source;
};
exports.toBusinessCentralCompany = toBusinessCentralCompany;
exports.default = ImportSource;
